var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenXLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4635_13698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4518 59.4518C53.3872 65.5161 43.5547 65.5161 37.4904 59.4518L32.0001 53.9612L26.5096 59.4518C20.4452 65.5161 10.6128 65.5161 4.54834 59.4518C-1.51611 53.3872 -1.51611 43.5547 4.54834 37.4904L10.2596 32.0001L4.54834 26.5096C-1.51612 20.4452 -1.51611 10.6128 4.54834 4.54834C10.6128 -1.51611 20.4452 -1.51611 26.5096 4.54834L32.0001 10.0387L37.4904 4.54834C43.5547 -1.51611 53.3872 -1.51611 59.4518 4.54834C65.5161 10.6128 65.5161 20.4452 59.4518 26.5096L53.9612 32.0001L59.4518 37.4904C65.5161 43.5547 65.5161 53.3872 59.4518 59.4518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67265 9.67265C6.43827 12.907 6.43827 18.151 9.67265 21.3854C12.1886 23.9014 15.9207 24.4602 18.9769 23.0618C19.8495 22.6626 20.667 22.1037 21.3854 21.3854C22.1037 20.667 22.6626 19.8495 23.0618 18.9769C24.4602 15.9207 23.9014 12.1886 21.3854 9.67265C18.151 6.43827 12.907 6.43827 9.67265 9.67265Z",
    fill: "#1D1D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5766 43.2335V54.1543C41.5766 55.5017 43.3231 56.2838 44.5768 55.4981L48.5646 52.9989L52.5522 55.4981C53.8062 56.2838 55.5527 55.5017 55.5527 54.1543V43.2335C55.5527 41.8861 53.8062 41.1042 52.5522 41.8897L48.5646 44.3889L44.5768 41.8897C43.3231 41.1042 41.5766 41.8861 41.5766 43.2335Z",
    fill: "#1D1D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3888 42.353C21.3888 41.3524 20.5776 40.5413 19.5771 40.5413H12.0714C11.1021 40.5413 10.3105 41.3025 10.2619 42.2596L10.2596 42.353V55.2939C10.2596 56.2944 11.0708 57.1056 12.0714 57.1056H19.5771L19.6703 57.1033C20.6276 57.0546 21.3888 56.2631 21.3888 55.2939C21.3888 54.3243 20.6276 53.5329 19.6703 53.4842L19.5771 53.4821H13.8831V50.6352H17.1183L17.2116 50.6328C18.1688 50.5842 18.93 49.7927 18.93 48.8234C18.93 47.8539 18.1688 47.0625 17.2116 47.0138L17.1183 47.0117H13.8831V44.1647H19.5771C20.5776 44.1647 21.3888 43.3536 21.3888 42.353Z",
    fill: "#1D1D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5646 17.2477C51.3787 17.2477 53.6682 15.0021 53.7392 12.2051L53.741 12.0714C53.741 9.39792 51.6075 7.22267 48.9503 7.15538L48.8234 7.15385H44.9412C43.9717 7.15385 43.1802 7.91506 43.1315 8.87231L43.1295 8.96557V21.9064C43.1295 22.907 43.9406 23.7181 44.9412 23.7181C45.9418 23.7181 46.7529 22.907 46.7529 21.9064V17.2477H48.5646Z",
    fill: "#1D1D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2086 12.0979C50.1752 11.4361 49.6447 10.9056 48.9829 10.8721L48.9164 10.8703H46.8458V13.7173H48.6575C49.5153 13.7173 50.2104 13.022 50.2104 12.1644L50.2086 12.0979Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4635_13698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenXLogoDark);
export default __webpack_public_path__ + "static/media/openXLogoDark.dfd7433cdd4f608f5eaa25965f19b7c7.svg";
export { ForwardRef as ReactComponent };